<div class="reset-password-body">
  <main class="main">
    <div class="ui-g">
      <div class="ui-g-12 flex-center-center">
        <div class="ui-g-4 flex-center-center">
          <div class="card p-4">
            <div class="card-body">
              <form>
                <div class="row justify-content-center mb-4">
                  <div class="col-md-8">
                    <img src="assets/alp_logo_transparent.png" class="img-fluid" alt="">
                    <div *ngIf="!authId?.isSetPasswordScreen">
                      <p *ngIf="state!=='set' && !authId.isSandboxUser" class="welcome">Resetting password for <br>
                        {{authId.email}}</p>
                      <p *ngIf="state!=='set' && authId.isSandboxUser" class="welcome">Resetting password for <br>
                        {{authId.email}}</p>
                      <p *ngIf="state==='set' && !authId.isSandboxUser" class="welcome">Setting password for <br>
                        {{authId.email}}</p>
                      <p *ngIf="state==='set' && authId.isSandboxUser" class="welcome">Setting password for <br>
                        {{authId.email}}</p>
                    </div>
                  </div>
                </div>
                <div *ngIf="authId?.isSetPasswordScreen">
                  <p class="welcome">
                    <b>Your password has expired.</b>
                    <br>
                    You must create a new strong password to continue. Please specify a
                    new password:
                  </p>
                </div>
                <div class="form-group">
                  <app-input type="password" placeholder="New password" [hasShowPasswordIcon]="true"
                    [errorMessage]="validate.newPassword" [isInvalid]="validate.newPassword" [value]="user.newPassword"
                    [floatingLabel]="true" [autoFocus]="true" (appChange)="onChange('newPassword', $event)"
                    (appFocus)="onFocus('newPassword')"></app-input>
                </div>

                <div class="form-group mb-15 mt-30">
                  <app-input type="password" placeholder="Confirm password" [hasShowPasswordIcon]="true"
                    [errorMessage]="validate.confirmPassword" [isInvalid]="validate.confirmPassword"
                    [value]="user.confirmPassword" [floatingLabel]="true"
                    (appChange)="onChange('confirmPassword', $event)" (appFocus)="onFocus('confirmPassword')">
                  </app-input>
                </div>

                <div class="row text-center">
                  <div class="col-md-12">
                    <span class="error-label" *ngIf="validate.general">{{validate.general}}</span>
                  </div>
                </div>

                <div class="row m-0 p-0 mt-2 mb-2 change-password-validations">
                  <ul>
                    <li>
                      Your new password must meet this criteria:
                    </li>
                    <li *ngFor="let rule of validationRules" [ngClass]="{ valid: rule.valid, invalid: !rule.valid }">
                      <span *ngIf="rule.valid">✔</span>
                      <span *ngIf="!rule.valid">✘</span>
                      {{ rule.message }}
                    </li>
                  </ul>
                </div>

                <div class="row">
                  <div class="col-sm-12 text-center mt-10" [ngClass]="!authId?.isSetPasswordScreen && 'mb-30'">
                    <button type="submit" (click)="onSubmit()" [disabled]=" !isFormValid()"
                      [ngClass]="{'not-allowed': !isFormValid()}" class="btn btn-block btn-primary btn-submit">
                      Set password
                      <!-- {{ authId?.isSetPasswordScreen ? 'Set password': 'Save'}} -->
                    </button>
                  </div>
                  <p *ngIf="!authId?.isSetPasswordScreen" class="mt-auto pointer font-primary hover-underline"
                    (click)="backToSignIn()">
                    Back to Sign-in
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
<ngx-loading-bar></ngx-loading-bar>